var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "colorSampleObserver", staticClass: "color-sample-checkout" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col col-12 col-md-6" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    var touched = ref.touched
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.billing_name,
                            expression: "data.billing_name",
                          },
                        ],
                        class: _vm.getInputClass(errors, touched),
                        attrs: {
                          type: "text",
                          name: "billing_name",
                          placeholder: _vm.trans("sample_order_name") + "*",
                        },
                        domProps: { value: _vm.data.billing_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data,
                              "billing_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col col-12 col-md-6" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    var touched = ref.touched
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.billing_address,
                            expression: "data.billing_address",
                          },
                        ],
                        class: _vm.getInputClass(errors, touched),
                        attrs: {
                          type: "text",
                          name: "billing_address",
                          placeholder:
                            _vm.trans("sample_order_street_and_house_number") +
                            "*",
                        },
                        domProps: { value: _vm.data.billing_address },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data,
                              "billing_address",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col col-12 col-md-6" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    var touched = ref.touched
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.billing_city,
                            expression: "data.billing_city",
                          },
                        ],
                        class: _vm.getInputClass(errors, touched),
                        attrs: {
                          type: "text",
                          name: "billing_city",
                          placeholder: _vm.trans("sample_order_city") + "*",
                        },
                        domProps: { value: _vm.data.billing_city },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data,
                              "billing_city",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col col-12 col-md-6" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    var touched = ref.touched
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.billing_zip,
                            expression: "data.billing_zip",
                          },
                        ],
                        class: _vm.getInputClass(errors, touched),
                        attrs: {
                          type: "text",
                          name: "billing_zip",
                          placeholder: _vm.trans("sample_order_zip_code") + "*",
                        },
                        domProps: { value: _vm.data.billing_zip },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data,
                              "billing_zip",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col col-12 col-md-6" },
          [
            _c("validation-provider", {
              attrs: { rules: "required|email" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    var touched = ref.touched
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.billing_email,
                            expression: "data.billing_email",
                          },
                        ],
                        class: _vm.getInputClass(errors, touched),
                        attrs: {
                          type: "text",
                          name: "billing_email",
                          placeholder: _vm.trans("sample_order_email") + "*",
                        },
                        domProps: { value: _vm.data.billing_email },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data,
                              "billing_email",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col col-12 col-md-6" },
          [
            _c("validation-provider", {
              attrs: { rules: { regex: _vm.phoneRegex, required: true } },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    var touched = ref.touched
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.billing_phone,
                            expression: "data.billing_phone",
                          },
                        ],
                        class: _vm.getInputClass(errors, touched),
                        attrs: {
                          type: "tel",
                          name: "billing_phone",
                          "voff-mask": "[...masks]",
                          placeholder: _vm.trans("sample_order_phone") + "*",
                        },
                        domProps: { value: _vm.data.billing_phone },
                        on: {
                          keydown: _vm.phoneKeyPress,
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data,
                              "billing_phone",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col col-12 col-md-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.billing_company_name,
                expression: "data.billing_company_name",
              },
            ],
            staticClass: "color-sample-input",
            attrs: {
              falsetype: "text",
              name: "billing_company_name",
              placeholder: _vm.trans("sample_order_company_name"),
            },
            domProps: { value: _vm.data.billing_company_name },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "billing_company_name", $event.target.value)
              },
            },
          }),
        ]),
        _c("div", { staticClass: "col col-12 col-md-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.billing_vat_number,
                expression: "data.billing_vat_number",
              },
            ],
            staticClass: "color-sample-input",
            attrs: {
              type: "text",
              name: "billing_vat_number",
              placeholder: _vm.trans("sample_order_vat_number"),
            },
            domProps: { value: _vm.data.billing_vat_number },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "billing_vat_number", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col col-12 col-md-6 color-order-billing-radio-container",
          },
          [
            _c("div", { staticClass: "radio-buttons" }, [
              _c("div", { staticClass: "radio-button" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sameAddress,
                      expression: "sameAddress",
                    },
                  ],
                  attrs: {
                    type: "radio",
                    id: "same_address",
                    name: "same_address",
                    checked: "true",
                  },
                  domProps: {
                    value: true,
                    checked: _vm._q(_vm.sameAddress, true),
                  },
                  on: {
                    change: function ($event) {
                      _vm.sameAddress = true
                    },
                  },
                }),
                _c("label", { attrs: { for: "same_address" } }, [
                  _c("span"),
                  _vm._v(
                    _vm._s(_vm.trans("sample_order_delivery_same_billing")) +
                      " "
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "col col-12 col-md-6 color-order-billing-radio-container",
          },
          [
            _c("div", { staticClass: "radio-buttons" }, [
              _c("div", { staticClass: "radio-button" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.sameAddress,
                      expression: "sameAddress",
                    },
                  ],
                  attrs: {
                    type: "radio",
                    id: "same_address_1",
                    name: "same_address",
                    checked: "false",
                  },
                  domProps: {
                    value: false,
                    checked: _vm._q(_vm.sameAddress, false),
                  },
                  on: {
                    change: function ($event) {
                      _vm.sameAddress = false
                    },
                  },
                }),
                _c("label", { attrs: { for: "same_address_1" } }, [
                  _c("span"),
                  _vm._v(
                    _vm._s(
                      _vm.trans("sample_order_delivery_different_billing")
                    ) + " "
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      !_vm.sameAddress
        ? [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col col-12 col-md-6" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var errors = ref.errors
                            var touched = ref.touched
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.data.name,
                                    expression: "data.name",
                                  },
                                ],
                                class: _vm.getInputClass(errors, touched),
                                attrs: {
                                  type: "text",
                                  name: "name",
                                  placeholder:
                                    _vm.trans("sample_order_name") + "*",
                                },
                                domProps: { value: _vm.data.name },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.data,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3681368934
                    ),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col col-12 col-md-6" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var errors = ref.errors
                            var touched = ref.touched
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.data.address,
                                    expression: "data.address",
                                  },
                                ],
                                class: _vm.getInputClass(errors, touched),
                                attrs: {
                                  type: "text",
                                  name: "address",
                                  placeholder:
                                    _vm.trans(
                                      "sample_order_street_and_house_number"
                                    ) + "*",
                                },
                                domProps: { value: _vm.data.address },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.data,
                                      "address",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3037366722
                    ),
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col col-12 col-md-6" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var errors = ref.errors
                            var touched = ref.touched
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.data.city,
                                    expression: "data.city",
                                  },
                                ],
                                class: _vm.getInputClass(errors, touched),
                                attrs: {
                                  type: "text",
                                  name: "city",
                                  placeholder:
                                    _vm.trans("sample_order_city") + "*",
                                },
                                domProps: { value: _vm.data.city },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.data,
                                      "city",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1951849446
                    ),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col col-12 col-md-6" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var errors = ref.errors
                            var touched = ref.touched
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.data.zip,
                                    expression: "data.zip",
                                  },
                                ],
                                class: _vm.getInputClass(errors, touched),
                                attrs: {
                                  type: "text",
                                  name: "zip",
                                  placeholder:
                                    _vm.trans("sample_order_zip_code") + "*",
                                },
                                domProps: { value: _vm.data.zip },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.data,
                                      "zip",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      695449460
                    ),
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col col-12 col-md-6" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required|email" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var errors = ref.errors
                            var touched = ref.touched
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.data.email,
                                    expression: "data.email",
                                  },
                                ],
                                class: _vm.getInputClass(errors, touched),
                                attrs: {
                                  type: "text",
                                  name: "email",
                                  placeholder:
                                    _vm.trans("sample_order_email") + "*",
                                },
                                domProps: { value: _vm.data.email },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.data,
                                      "email",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      164312198
                    ),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col col-12 col-md-6" },
                [
                  _c("validation-provider", {
                    attrs: { rules: { regex: _vm.phoneRegex, required: true } },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var errors = ref.errors
                            var touched = ref.touched
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.data.phone,
                                    expression: "data.phone",
                                  },
                                ],
                                class: _vm.getInputClass(errors, touched),
                                attrs: {
                                  type: "text",
                                  name: "phone",
                                  placeholder:
                                    _vm.trans("sample_order_phone") + "*",
                                  "voff-mask": "[...masks]",
                                },
                                domProps: { value: _vm.data.phone },
                                on: {
                                  keydown: _vm.phoneKeyPress,
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.data,
                                      "phone",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4194324768
                    ),
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col col-12 col-md-6" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.company_name,
                      expression: "data.company_name",
                    },
                  ],
                  staticClass: "color-sample-input",
                  attrs: {
                    type: "text",
                    name: "company_name",
                    placeholder: _vm.trans("sample_order_company_name"),
                  },
                  domProps: { value: _vm.data.company_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "company_name", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "col col-12 col-md-6" }),
            ]),
          ]
        : _vm._e(),
      _c("div", { staticClass: "row checkboxGroup mt-3" }, [
        _c(
          "div",
          { staticClass: "checkbox-buttons" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    var touched = ref.touched
                    return [
                      _c(
                        "label",
                        { class: _vm.getLabelClass(errors, touched) },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.data.checkbox_1,
                                expression: "data.checkbox_1",
                              },
                            ],
                            class: ["form-check-input checkbox"],
                            attrs: {
                              type: "checkbox",
                              id: "checkbox_1",
                              name: "checkbox_1",
                              value: "checked",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.data.checkbox_1)
                                ? _vm._i(_vm.data.checkbox_1, "checked") > -1
                                : _vm.data.checkbox_1,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.data.checkbox_1,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "checked",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.data,
                                          "checkbox_1",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.data,
                                          "checkbox_1",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.data, "checkbox_1", $$c)
                                  }
                                },
                                _vm.onCheckboxChange1,
                              ],
                            },
                          }),
                          _c("span", {
                            staticClass: "mdi mdi-name check-span",
                          }),
                          _c("span", {
                            staticClass: "checkbox-text mb-2",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.trans("sample_order_privacy_policy")
                              ),
                            },
                          }),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "row checkboxGroup" }, [
        _c(
          "div",
          { staticClass: "checkbox-buttons" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    var touched = ref.touched
                    return [
                      _c(
                        "label",
                        { class: _vm.getLabelClass(errors, touched) },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.data.checkbox_2,
                                expression: "data.checkbox_2",
                              },
                            ],
                            class: ["form-check-input checkbox"],
                            attrs: {
                              type: "checkbox",
                              id: "checkbox_2",
                              name: "checkbox_2",
                              value: "checked",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.data.checkbox_2)
                                ? _vm._i(_vm.data.checkbox_2, "checked") > -1
                                : _vm.data.checkbox_2,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.data.checkbox_2,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "checked",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.data,
                                          "checkbox_2",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.data,
                                          "checkbox_2",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.data, "checkbox_2", $$c)
                                  }
                                },
                                _vm.onCheckboxChange2,
                              ],
                            },
                          }),
                          _c("span", {
                            staticClass: "mdi mdi-name check-span",
                          }),
                          _c("span", {
                            staticClass: "checkbox-text mb-4",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.trans("sample_order_data_handling")
                              ),
                            },
                          }),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "row mt-5 mb-5" }, [
        _c("div", { staticClass: "col-6" }, [
          _c(
            "button",
            {
              staticClass: "button type-15 sample-order-checkout-back-button",
              attrs: { type: "button" },
              on: { click: _vm.goBack },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("keyboard_backspace"),
              ]),
              _vm._v(" " + _vm._s(_vm.trans("calc_navigation_back")) + " "),
            ]
          ),
        ]),
        _c("div", { staticClass: "col-6 text-right" }, [
          _c(
            "button",
            {
              class:
                "sample_order_next_button button type-1 " + _vm.forwardclass,
              attrs: { type: "button" },
              on: { click: _vm.goForward },
            },
            [_vm._v(" " + _vm._s(_vm.trans("general_next")) + " ")]
          ),
        ]),
      ]),
      false
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _c("span", { staticClass: "color-order-basket-title mb-3" }, [
                _vm._v(_vm._s(_vm.trans("sample_order_in_your_basket")) + ":"),
              ]),
              _c("color-sample-overview", {
                attrs: {
                  canModifyQuantity: false,
                  canModifyStructure: false,
                  items: _vm.items,
                  currency: _vm.currency,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }